import gsap from 'gsap'
import Korg from 'reed-korg'
import { Flip } from 'gsap/Flip'
import BaseComponent from './_BaseComponent'

gsap.registerPlugin(Flip)


/* Smart guides filters
----------------------------------------------------------------------------------------------------*/

export default class Filters extends BaseComponent {

    constructor($el, namespace) {
        super('Filters', $el, namespace)
        this.openClass = 'is-open'
        this.cards = document.querySelectorAll(this.$el[0].dataset.cards)
        this.noResults = document.querySelector(this.$el[0].dataset.noResults)

        this.korg = new Korg(this.$refs.form[0])

        this.on()
    }


    bindProperties() {
        this.isOpen = false
    }


    bindHandlers() {
        this.clickHandler = e => this.onTriggerClick(e)
        this.formChangeHandler = e => this.onFormChange(e)
        this.clickBodyHandler = e => this.onBodyClick(e)
        this.closeHandle = e => this.onCloseClick(e)
    }


    bindEvents() {
        const { $trigger, $form, $close } = this.$refs
        const { $body } = this.$utils

        this.addListeners(
            [$close, 'click', this.closeHandle],
            [$trigger, 'click', this.clickHandler],
            [$form, 'change', this.formChangeHandler],
            [$body, 'click', this.clickBodyHandler],
        )
    }




    /* Handlers
    --------------------------------------------------------- */


    onCloseClick() {
        this.toggle(false)
        this.isOpen = false
    }

    onTriggerClick() {
        this.toggle()
        this.isOpen = !this.isOpen
    }

    onBodyClick(e) {
        // Do nothing if already closed
        if (!this.isOpen) return

        // Check if user clicked on the trigger on within the overlay
        const shouldClose = e.target === this.$refs.$trigger[0]
            || this.$refs.$trigger[0].contains(e.target)
            || e.target === this.$refs.$form[0]
            || this.$refs.$form[0].contains(e.target)

        // If user clicked outside of component, close it
        if (!shouldClose) {
            this.toggle(false)
            this.isOpen = false
        }
    }

    onFormChange() {
        // Remove selected theme to remove selected category
        window.history.replaceState({}, document.title, window.location.pathname);

        const state = Flip.getState('.smartGuidesItem')

        const activeCategories = this.$refs.$inputs.filter(input => input.checked).map(input => input.value)

        // Calculate how many cards are visible
        let totalVisible = 0

        // Filter the cards based on the picked categories
        this.cards.forEach((card) => {
            // If at least one category is picked
            if (activeCategories.length) {
                let isVisible = false
                const cardCategories = card.dataset.categories.split(';')
                // Compare the active categories with the cards'
                activeCategories.forEach((category) => {
                    // Only do the check if it didn't match a category yet
                    if (!isVisible) {
                        isVisible = cardCategories.indexOf(category) > -1
                    }
                })
                card.classList.toggle('is-hidden', !isVisible)

                if (isVisible) totalVisible += 1
            } else {
                card.classList.remove('is-hidden')
                totalVisible += 1
            }
        })

        Flip.from(state, {
            absolute: true,
            ease: 'power1.inOut',
            targets: '.smartGuidesItem',
            scale: true,
            simple: true,
            onEnter(elements) {
                return gsap.fromTo(elements, {
                    opacity: 0,
                    scale: 0,
                }, {
                    opacity: 1,
                    scale: 1,
                    delay: 0.2,
                    duration: 0.3,
                })
            },
            onLeave(elements) {
                return gsap.to(elements, {
                    opacity: 0,
                    scale: 0,
                    duration: 0.5,
                })
            },
        })

        // Toggle the no results section
        this.noResults.classList.toggle('is-visible', totalVisible === 0)
    }




    /* Actions
    --------------------------------------------------------- */


    toggle(shouldOpen = !this.isOpen) {
        this.$el[0].classList.toggle(this.openClass, shouldOpen)

        this.$utils.$doc.trigger('overlayToggled', { isOpen : shouldOpen, trigger: 'stepNav' })
        this.korg.toggle(shouldOpen)
    }

}
